import { SxProps } from '@mui/material'

const styles = {
  button: {
    color: 'text.primary',
    textTransform: 'none',
    fontSize: '0.9375rem',
    fontWeight: 400,
    padding: '6px 12px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    },
    minWidth: 'auto'
  } as SxProps,
  menu: {
    '& .MuiPaper-root': {
      minWidth: 180,
      marginTop: 1,
      boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)'
    }
  } as SxProps,
  menuItem: {
    fontSize: '0.9375rem',
    padding: '10px 20px',
    '&.Mui-selected': {
      backgroundColor: 'action.selected',
      fontWeight: 600,
      '&:hover': {
        backgroundColor: 'action.hover'
      }
    },
    '&:hover': {
      backgroundColor: 'action.hover'
    }
  } as SxProps
}

export default styles
